import { render, staticRenderFns } from "./AnalysisProduct.vue?vue&type=template&id=23bc4eea&scoped=true&"
import script from "./AnalysisProduct.vue?vue&type=script&lang=js&"
export * from "./AnalysisProduct.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisProduct.vue?vue&type=style&index=0&id=23bc4eea&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc4eea",
  null
  
)

export default component.exports